import { Component, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, NgZone } from '@angular/core';
import { Chart, registerables } from 'chart.js/auto';
import autocolors from 'chartjs-plugin-autocolors';
import { Subscription } from 'rxjs';
import { DashboardService } from '../../../services/dashboard.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

Chart.register(autocolors, ...registerables);

@Component({
	selector: 'app-dashboard-cat-line',
	templateUrl: './dashboard-cat-line.component.html',
	styleUrls: ['./dashboard-cat-line.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardCatLineComponent implements OnDestroy {
	catandlines: any = false;
	loading = false;
	catchart: any = false;
	linechart: any = false;
	linechartreverse: any = false;
	config: any = false;
	private configSub: Subscription;
	private catlineSub: Subscription;

	constructor(
		private dashboardService: DashboardService,
		private globalSearchService: GlobalSearchService,
		private cdr: ChangeDetectorRef,
		private ngZone: NgZone
	) {
		this.configSub = this.globalSearchService.configsubscription.subscribe(r => {
			if (r) {
				this.config = r;
				this.loadData();
			}
		});
	}

	ngOnDestroy() {
		this.configSub?.unsubscribe();
		this.catlineSub?.unsubscribe();
		if (this.catchart && typeof this.catchart.destroy === 'function') {
			this.catchart.destroy();
		}
		if (this.linechart && typeof this.linechart.destroy === 'function') {
			this.linechart.destroy();
		}
		if (this.linechartreverse && typeof this.linechartreverse.destroy === 'function') {
			this.linechartreverse.destroy();
		}
	}

	loadData() {
		this.loading = true;
		this.cdr.markForCheck();
		this.catlineSub = this.dashboardService.getCatAndLines().subscribe((results: any) => {
			this.catandlines = results;
			this.loading = false;
			this.cdr.markForCheck();
			this.ngZone.run(() => {
				setTimeout(() => {
					this.buildAllCharts(results);
					this.cdr.markForCheck();
				}, 0);
			});
		});
	}

	private static readonly TOP_N = 10;

	formatData(data: any[] = [], title: string, expanded = false) {
		const _labels: string[] = [];
		const _series: number[] = [];
		const arr = Array.isArray(data) ? data.slice(0, expanded ? data.length : DashboardCatLineComponent.TOP_N) : [];
		arr.forEach((r: any) => {
			_labels.push(r?.label ?? '');
			const val = this.config?.env?.package === 'tires' ? r?.qty : r?.value;
			_series.push(typeof val === 'number' ? val : parseFloat(val) || 0);
		});
		return {
			labels: _labels,
			datasets: [{ fill: false, label: title, data: _series }]
		};
	}

	buildAllCharts(results: any) {
		const catdata = this.formatData(results.category_sales || [], 'Category Sales', false);
		const lineArr = Array.isArray(results.line_sales) ? results.line_sales : [];
		const lineRevArr = Array.isArray(results.line_sales_reversed) ? results.line_sales_reversed : [];
		const linedata = this.formatData(lineArr, 'Product Line Sales', false);
		const linedatar = this.formatData(lineRevArr, 'Product Line Sales', false);

		if (this.catchart && typeof this.catchart.destroy === 'function') {
			this.catchart.destroy();
		}
		this.catchart = new Chart('counterPosCatChartRef', {
			type: 'bar',
			data: catdata,
			options: {
				responsive: true,
				indexAxis: 'y',
				plugins: {
					legend: { position: 'bottom' },
					title: { display: false, text: 'Category Sales' },
					autocolors: { enabled: true, mode: 'data' }
				}
			}
		});

		if (this.linechart && typeof this.linechart.destroy === 'function') {
			this.linechart.destroy();
		}
		this.linechart = new Chart('counterPosPlineChart', {
			type: 'bar',
			data: linedata,
			options: {
				indexAxis: 'y',
				responsive: true,
				plugins: {
					legend: { position: 'bottom' },
					title: { display: false, text: 'Product Line Sales' },
					autocolors: { enabled: true, mode: 'data' }
				}
			}
		});

		if (this.linechartreverse && typeof this.linechartreverse.destroy === 'function') {
			this.linechartreverse.destroy();
		}
		this.linechartreverse = new Chart('counterPosPlineChartR', {
			type: 'bar',
			data: linedatar,
			options: {
				indexAxis: 'y',
				responsive: true,
				plugins: {
					legend: { position: 'bottom' },
					title: { display: false, text: 'Product Line Sales' },
					autocolors: { enabled: true, offset: 3, mode: 'data' }
				}
			}
		});
	}
}
